// Array
export const LANGUAGES = ['en', 'it', 'es'];

// String
export const EMPTY_STRING = '';
export const GENERATE_AVATAR_BASE_URL = 'https://ui-avatars.com/api/';
export const INVALID_VALUE = 'Invalid';
export const TIME_DEFAULT_LABEL = '00:00:00';
export const ENGLISH_VIDEO_LESSON_SUBTITLE = 'ENG';
export const ITALIAN_VIDEO_LESSON_SUBTITLE = 'ITA';
export const SELECTION_OPTION_ID = 'SELECT_EMPTY';

// Number
export const DEFAULT_NUMBER_ONE = 1;
export const DEFAULT_NUMBER_ZERO = 0;
export const TIMEOUT_ALERT_MILLISECOND = 3000;
export const DEFAULT_LIMIT = 1000;
export const DEFAULT_PAGE = 1;
export const DEFAULT_LIMIT_PAGE = 3;
export const MAX_VIDEO_TIME_FORWARD = 2;
export const TIMEOUT_REFRESH_DISCUSSION = 500;
export const TIME_CLOSE_TOAST = 4000;
export const TIME_OUT_SHOW_TOAST = 1000;
export const TIME_OUT_SHOW_TOAST_ERROR = 200;
export const TIME_OUT_SHOW_TOAST_SUCCESS = 1000;
export const SECOND_PER_LIMIT = 60;
export const MILLISECOND_PER_SECOND = 1000;
export const TIMEOUT_RE_ANSWER_QUESTION = 2000;
export const LAST_SECONDS_TO_MARK_WATCHED = 180;
export const PROGRESS_POST_INTERVAL_MS = 10000;

// Regex
export const REG_EXP = {
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  QUERY: /%20/g,
};

// Components

// Date
export const DATE_FORMAT = {
  DATE: 'MM/DD/YYYY',
  LONG_FORMAT: 'MMMM D, YYYY',
  TIME: 'hh:mm A',
  PDF_DATE: 'hh:mm A MM/DD/YYYY',
};
